import { render, staticRenderFns } from "./collection.vue?vue&type=template&id=65cab299&scoped=true&lang=pug&"
import script from "./collection.vue?vue&type=script&lang=js&"
export * from "./collection.vue?vue&type=script&lang=js&"
import style0 from "./collection.vue?vue&type=style&index=0&id=65cab299&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cab299",
  null
  
)

export default component.exports